import { render, staticRenderFns } from "./vuetourTest.vue?vue&type=template&id=628c0ab8&"
import script from "./vuetourTest.vue?vue&type=script&lang=js&"
export * from "./vuetourTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports